import { Box, Text, Stack, Inline, Badge } from 'braid-design-system';
import clsx from 'clsx';
import type React from 'react';

import * as styles from './row.css';

interface IconRowProps {
  icon?: React.ReactNode;
  onClick?: () => void;
  label: string;
  inactive?: boolean;
  inactiveDescription?: string;
  content: React.ReactNode;
}

const IconRow: React.FC<React.PropsWithChildren<IconRowProps>> = ({
  icon,
  onClick,
  label,
  inactive = false,
  inactiveDescription,
  content,
}) => (
  <Box
    onClick={onClick}
    className={clsx({
      [styles.clickable]: onClick,
      [styles.inactive]: inactive,
    })}
  >
    <Stack space="xxsmall">
      <Box display="flex" alignItems="center">
        <Box marginRight="xsmall">{icon}</Box>
        <Inline space="small" align="left">
          <Text size="small">{label}</Text>
          {label === 'Add locations' && (
            <Badge tone="promote" bleedY>
              Beta
            </Badge>
          )}
        </Inline>
      </Box>
      <Box
        style={{
          whiteSpace: 'normal',
          marginLeft: '38px',
        }}
      >
        {inactive && inactiveDescription !== undefined && (
          <Text tone="secondary" size="small">
            {inactiveDescription}
          </Text>
        )}
        {!inactive && <>{content}</>}
      </Box>
    </Stack>
  </Box>
);

export default IconRow;
